import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { Url } from '@wix/da-url';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import GiveBadge from '@wix/da-ds/pkg/Icons/24x24/GiveBadge';
import MltSearch16 from '@wix/da-ds/pkg/Icons/16x16/MltSearch';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { beginDeviationAwardBadgeFlow } from '../../../../../coreBadge/redux/actionCreators';
import { AwardBadgeSource } from '../../../../../coreBadge/types';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import FaveControl from '../../../legos/FaveControl';
import CommentControl from '../../../legos/CommentControl';
import { getDeviationResourceType, getIsPost } from '../../../../../DeviationViews/_helpers';
import { DeviationResourceType } from '../../../../../types/deviation';
import { useSubscriptionTier } from '../../../../../utils/hooks/useSubscriptionTier';
import { useRestrictToLoggedIn } from '../../../../../utils/hooks/useRestrictToLoggedIn';
import s from './BottomInfoBar.scss';
const BottomInfoBar = ({ deviation, className })=>{
    var _deviation_author;
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const { showCommentControl, showFaveControl } = useOverlayContext(deviation);
    const dispatch = useDispatch();
    const { restrictToLoggedIn } = useRestrictToLoggedIn();
    const resourceType = getDeviationResourceType(deviation);
    const { needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const isMlt = useFlag('mlt') && resourceType === DeviationResourceType.ART && !getIsPost(deviation) && !(needsSubscription || isSubscribedButBlocked);
    const handleAwardBadgeClick = useCallback(()=>{
        dispatch(beginDeviationAwardBadgeFlow(deviation, AwardBadgeSource.THUMB_INFO));
    }, [
        deviation,
        dispatch
    ]);
    const onMlt = useCallback(()=>{
        window.location.assign(Url.moreLikeThisLink(deviation.deviationId));
    }, [
        deviation
    ]);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['with-badges'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['controls']
    }, showFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        deviation: deviation,
        className: s['stat']
    }), showCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        deviation: deviation,
        className: s['stat']
    })), (!isAuthor || isMlt) && /*#__PURE__*/ React.createElement("div", {
        className: s['actions']
    }, !isAuthor && /*#__PURE__*/ React.createElement(BiButton, {
        className: s['award-button'],
        onClick: restrictToLoggedIn(ReferralType.AWARD_BADGE, handleAwardBadgeClick),
        biData: BiData({
            evid: 320,
            sectionname: BiContextProvidedValue,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })
    }, /*#__PURE__*/ React.createElement(GiveBadge, null)), isMlt && /*#__PURE__*/ React.createElement(BiButton, {
        className: s['mlt-button'],
        onClick: onMlt,
        biData: BiData({
            evid: 126,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            sectionname: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement(MltSearch16, {
        className: s['mlt-icon']
    }))));
};
BottomInfoBar.displayName = 'BottomInfoBar';
export default BottomInfoBar;

//# sourceMappingURL=BottomInfoBar.js.map